// Copyright 2020 Prescryptive Health, Inc.

export class LoginInProgressError extends Error {
  constructor() {
    super();
    Object.setPrototypeOf(this, LoginInProgressError.prototype);
  }
}
